import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import AnimationContainer from "../../Reusable/AnimationContainer/AnimationContainer.js";
import { usePopupContextMenu } from "../../../contexts/popupContextMenuContext/popupContextMenuContext.js";
import Icon from "../../Elements/Icon/Icon.tsx";
import useOnClickOutside from "../../../hooks/useOnClickOutside.js";
import DownloadActionComponent from "../FilesActionGroup/DownloadAction.js";
import PreviewActionComponent from "../FilesActionGroup/PreviewFileAction.js";
import CoverImageAction from "../FilesActionGroup/UpdateCoverAction.js";
import ShareActionComponent from "../FilesActionGroup/ShareAction.js";
import InfoActionComponent from "../FilesActionGroup/InfoAction.js";
import ReportAction from "../FilesActionGroup/ReportAction.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import useMailSender from "../../../hooks/useMailSender.js";

const ContextActionItem = ({ children, title, isDisabled }) => {
  const actionHandler = (e) => {
    const target = e.target;
    if (target.tagName === "SPAN")
      target.parentElement.querySelector("img").click();
    if (target.tagName === "DIV") target.querySelector("img").click();
  };
  return (
    <div className="flex-row" onClick={actionHandler}>
      {children}
      <span className={`${isDisabled ? "disabled-text" : ""}`}>{title}</span>
    </div>
  );
};

const GridContextMenuManager = () => {
  const { getTextByKey } = useContent();
  const { getFilesData, getMailSecurity } = useMail();

  const { isMailSenderAndBusinessSubscriber, isMailSender } = useMailSender();
  const [stylePosition, setStylePosition] = useState({});

  const { getPosition, getOpenCondition, getContent, closePopup, getFileId } =
    usePopupContextMenu();
  const contextRef = useRef();

  useLayoutEffect(() => {
    if (contextRef.current) {
      const limit = document.documentElement.scrollHeight;
      const topPosition =
        (getPosition().top +
          window.scrollY +
          contextRef.current.offsetHeight +
          10 >
        limit
          ? getPosition().top +
            window.scrollY -
            contextRef.current.offsetHeight -
            10
          : getPosition().top + window.scrollY + 10) + "px";
      const leftPosition =
        (getPosition().left + contextRef.current.offsetWidth + 30 >
        window.innerWidth -
          (document.querySelector(".side-bar-container")
            ? document.querySelector(".side-bar-container").offsetWidth
            : 0)
          ? getPosition().left - contextRef.current.offsetWidth - 10
          : getPosition().left + 10) + "px";
      setStylePosition({
        top: topPosition,
        left: leftPosition,
      });
    }
  }, [getPosition()]);

  useOnClickOutside(contextRef, () => closePopup());

  return (
    <AnimationContainer
      animationOn={getOpenCondition()}
      animationClassName="hover-item-fade"
    >
      <div
        className="grid-context-menu"
        ref={contextRef}
        style={stylePosition}
        onClick={() => closePopup()}
      >
        <div className="context-menu-header">
          <Icon name="x" onClick={closePopup} gray small />
        </div>
        {getContent() || (
          <>
            <div className="">
              <ContextActionItem
                title={getTextByKey("gallerycontextmenu-preview")}
              >
                <PreviewActionComponent
                  itemId={getFileId()}
                  tooltipDisabled={true}
                />
              </ContextActionItem>
              {getMailSecurity()?.previewFiles ? null : (
                <ContextActionItem
                  title={getTextByKey("gallerycontextmenu-download")}
                >
                  <DownloadActionComponent
                    itemId={getFileId()}
                    tooltipDisabled={true}
                  />
                </ContextActionItem>
              )}
              {getFileId() &&
                getFilesData()[getFileId()]?.Type.toLowerCase() === "image" &&
                isMailSender() && (
                  <ContextActionItem
                    title={getTextByKey("gallerycontextmenu-usecoverimage")}
                  >
                    <CoverImageAction
                      itemId={getFileId()}
                      isDisabled={!isMailSenderAndBusinessSubscriber()}
                      tooltipDisabled={true}
                    />
                  </ContextActionItem>
                )}
              {getMailSecurity()?.isSharingDisabled ? null : (
                <ContextActionItem
                  title={getTextByKey("gallerycontextmenu-share")}
                >
                  <ShareActionComponent
                    itemId={getFileId()}
                    iconName="share-solid"
                    tooltipDisabled={true}
                  />
                </ContextActionItem>
              )}
            </div>
            <div className="horizontal-divider" />
            <div className="">
              <ContextActionItem
                title={getTextByKey("gallerycontextmenu-report")}
              >
                <ReportAction tooltipDisabled={true} />
              </ContextActionItem>
              <ContextActionItem
                title={getTextByKey("gallerycontextmenu-info")}
              >
                <InfoActionComponent
                  itemId={getFileId()}
                  tooltipDisabled={true}
                />
              </ContextActionItem>
            </div>
          </>
        )}
      </div>
    </AnimationContainer>
  );
};

export default GridContextMenuManager;
